import { tableAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    tableAnatomy.keys,
)

const variants = {
    rounded: defineStyle(() => {
        return definePartsStyle({
            thead: {
                bgColor: 'beige.darkened',
                th: {
                    py: '14px',
                    px: '15px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                    lineHeight: '0.9375rem',
                    color: 'captions.light',
                    fontFamily: 'Graphik',
                    letterSpacing: 'inherit',
                    '&:first-of-type': {
                        borderTopLeftRadius: '6px',
                    },
                    '&:last-of-type': {
                        borderTopRightRadius: '6px',
                    },
                },
            },
            tbody: {
                bgColor: 'white',
                borderTopRightRadius: '6px',
                tr: {
                    cursor: 'pointer',
                    _hover: {
                        bgColor: 'beige.highlighted',
                    },
                    '&:not(:last-of-type)': {
                        td: {
                            borderBottom: '1px solid',
                            borderColor: 'green.transparent_10',
                        },
                    },
                },
            },
            tr: {
                '&:last-of-type': {
                    td: {
                        '&:first-of-type': {
                            borderBottomLeftRadius: '6px',
                        },
                        '&:last-of-type': {
                            borderBottomRightRadius: '6px',
                        },
                    },
                },
            },
            td: {
                p: '15px',
                fontSize: '0.875rem',
                lineHeight: '1.3125rem',
            },
        })
    }),
}

export const Table = defineMultiStyleConfig({
    variants,
})
